import React, {useContext, useEffect, useRef, useState} from 'react';
import './GameStatisticContainer.scss';
import {Context} from "../../App";
import Utils from "../../utils/Utils";
import {GAME_MATCH_ID_RESULT, GAME_RESULTS_DATA} from "../../services/RequestDatas";
import RequestManager from "../../services/RequestManager";
import VirtualHorseStatItem from "./StatisticsItems/VirtualHorseStatItem/VirtualHorseStatItem";
import VirtualBicycleStatItem from "./StatisticsItems/VirtualBicycleStatItem/VirtualBicycleStatItem";
import BasicStatItem from "./StatisticsItems/BasicStatItem/BasicStatItem";
import VirtualGreyhoundsStatItem from "./StatisticsItems/VirtualGreyhoundsStatItem/VirtualGreyhoundsStatItem";
import STWDeluxeStatItem from "./StatisticsItems/STWDeluxeStatItem/STWDeluxeStatItem";
import STWStatItem from "./StatisticsItems/STWStatItem/STWStatItem";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ResultItem from "./StatisticsItems/ResultItem/ResultItem";
import {useTranslation} from "react-i18next";

function GameStatisticContainer() {
  const context = useContext(Context);
  const activeGameID = context.activeGameID.get;
  const {t} = useTranslation();
  const iconBaseURL = process.env.PUBLIC_URL + './assets/icons/';
  const socket = RequestManager.getInstance().webSocket;

  const dayBySeconds = 24 * 60 * 60 * 1000;
  const [startDate, setStartDate] = useState(Date.now() - dayBySeconds);
  const [endDate, setEndDate] = useState(Date.now());
  const [loadingProcess, setLoadingProcess] = useState(true);
  const [gameResults, setGameResults] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const matchId = useRef();
  const fromCalendar = useRef();
  const toCalendar = useRef();

  const statItemsData = {
    1: <BasicStatItem/>,
    2: <BasicStatItem/>,
    3: <VirtualHorseStatItem/>,
    4: <VirtualGreyhoundsStatItem/>,
    6: <VirtualBicycleStatItem/>,
    7: <BasicStatItem/>,
    8: <STWStatItem/>,
    9: <BasicStatItem/>,
    12: <BasicStatItem/>,
    13: <BasicStatItem/>,
    14: <BasicStatItem/>,
    15: <STWDeluxeStatItem/>,
    16: <VirtualHorseStatItem/>,
    17: <VirtualGreyhoundsStatItem/>,
    18: <VirtualBicycleStatItem/>,
    19: <BasicStatItem/>
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getGameResults();

    document.addEventListener("keydown", handleEnterSearch);

    return () => {
      document.removeEventListener("keydown", handleEnterSearch);
    };
  }, [])

  const handleEnterSearch = event => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      event.preventDefault();
      searchResult();
    }
  }

  const getGameResults = () => {
    setLoadingProcess(true);

    const fromDate = Math.floor(startDate / 1000);
    const toDate = Math.floor(endDate / 1000);

    GAME_RESULTS_DATA.params.sport_id = activeGameID;
    GAME_RESULTS_DATA.params.from_date = toDate === fromDate ? fromDate - 36000 : fromDate;
    GAME_RESULTS_DATA.params.to_date = toDate;
    GAME_RESULTS_DATA.params.competition_id = matchId.current ? parseInt(matchId.current) : 0;

    socket.send(JSON.stringify(GAME_RESULTS_DATA));
    socket.addEventListener(RequestManager.GAME_RESULTS_EVENT, initGameResults, {once: true});
  }

  const getResultByMatchId = () => {
    GAME_MATCH_ID_RESULT.params.game_id = Number(matchId.current);
    GAME_MATCH_ID_RESULT.rid = Utils.getUniqNumber().toString();

    socket.send(JSON.stringify(GAME_MATCH_ID_RESULT));
    socket.addEventListener(RequestManager.GAME_MATCH_ID_RESULTS_EVENT, initMatchIdGameResults, {once: true});
  }

  const initMatchIdGameResults = ({detail}) => {
    const results = detail.data.lines.line;

    setLoadingProcess(false);
    setSearchResults(results);
  }

  const initGameResults = ({detail}) => {
    if (!detail.data['games']) {
      return;
    }

    const results = detail.data['games']['game'];
    setGameResults(results);
    setLoadingProcess(false);
  }

  const getResultsList = () => {
    if (searchResults) {

      return <div className="results-list-container">
        {
          searchResults.map((data, index) => {
            return <ResultItem data={data} index={index} key={index}/>
          })
        }
      </div>
    }

    return loadingProcess
      ? <div className="results-loader"/>
      : <div className="results-list-container">
        {
          gameResults.map((data, index) => {
            try {
              return React.cloneElement(statItemsData[activeGameID], {data, index, key: index})
            } catch (error) {
              console.log('>> ERROR:', error, activeGameID)
            }
          })
        }
      </div>
  }

  const searchResult = () => {
    setLoadingProcess(true);

    if (matchId.current) {
      getGameResults();
    } else {
      setSearchResults(null);
      getGameResults();
    }
  }

  const changeResultsDate = (date, dateType) => {
    const selectedDateTimestamp = date.valueOf();
    const twoDayBySeconds = 2 * dayBySeconds;

    if (dateType === "start") {
      setStartDate(selectedDateTimestamp);

      if (selectedDateTimestamp + twoDayBySeconds < endDate) {
        setEndDate(selectedDateTimestamp + twoDayBySeconds);
      }
    } else if (dateType === "end") {
      setEndDate(selectedDateTimestamp);

      if (selectedDateTimestamp - twoDayBySeconds > startDate) {
        setStartDate(selectedDateTimestamp - twoDayBySeconds);
      }
    }
  }

  const manageCalendarClosing = (event, calendarType) => {
    if (event.target.tagName === 'INPUT') {
      if (calendarType === 'from' && fromCalendar.current.state.open) {
        setTimeout(() => fromCalendar.current.setOpen(false), 200);
      } else if (calendarType === 'to' && toCalendar.current.state.open) {
        setTimeout(() => toCalendar.current.setOpen(false), 200);
      }
    }
  }

  const getSearchPanel = () => {

    return <div className="history-filter">
      <div className="history-filter filter-bet-id">
        <p>{t('round id')}:</p>
        <input type="number" className="bet-id-input"
               onChange={e => matchId.current = e.target.value}
               onPaste={e => Utils.blockInvalidPastedNumbers(e)}
               onKeyDown={Utils.blockInvalidNumbers}/>
      </div>
      <div className='filter-calendars'>
        <div className="search-calendar" onMouseDown={event => manageCalendarClosing(event, 'from')}>
          {matchId.current && <div className="disable-input"></div>}
          <DatePicker ref={fromCalendar} className='calendar-input start' selected={startDate} maxDate={endDate}
                      timeFormat="HH:mm" onChange={date => changeResultsDate(date, 'start')}
                      onFocus={e => e.target.readOnly = true} readOnly={!!matchId.current}/>
          <img className="calendar-icon" src={iconBaseURL + 'calendar.svg'} alt=''/>
        </div>
        <div className="search-calendar" onMouseDown={event => manageCalendarClosing(event, 'to')}>
          {matchId.current && <div className="disable-input"></div>}
          <DatePicker ref={toCalendar} className='calendar-input end' selected={endDate} minDate={startDate}
                      maxDate={Date.now()} timeFormat="HH:mm" onChange={date => changeResultsDate(date, 'end')}
                      onFocus={e => e.target.readOnly = true} readOnly={!!matchId.current}/>
          <img className="calendar-icon" src={iconBaseURL + 'calendar.svg'} alt=''/>
        </div>
      </div>
      <img className='search-icon' src={iconBaseURL + 'search.png'} alt='' onClick={searchResult}/>
    </div>
  }

  return <div className='games-statistic-container'>
    <div className='header'>
      <img className='back' src={iconBaseURL + 'back.png'} alt='' onClick={() => context.activeGameID.set(null)}/>
      <p>{t('view games history')}</p>
      <img className='close' src={iconBaseURL + 'close.png'} alt='' onClick={() => context.activeGameID.set(null)}/>
    </div>
    <div className="sub-header">
      {t(Utils.GAME_NAMES[activeGameID].replace(/ /g, '')).toUpperCase()}
    </div>
    <div className="sub-sub-header">
      <p>{t('rdr')}</p>
      {
        getSearchPanel()
      }
    </div>
    {
      getResultsList()
    }
  </div>
}

export default GameStatisticContainer;